import { render, staticRenderFns } from "./SettingsStatuses.vue?vue&type=template&id=12fd964a&scoped=true&lang=pug&"
import script from "./SettingsStatuses.vue?vue&type=script&lang=js&"
export * from "./SettingsStatuses.vue?vue&type=script&lang=js&"
import style0 from "./SettingsStatuses.vue?vue&type=style&index=0&id=12fd964a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd964a",
  null
  
)

export default component.exports